const getDefaultFundAllocations = (amount) => {
  const total = Number(amount);
  if (!Number.isFinite(total) || total < 0 || !Number.isInteger(total)) {
    throw new Error(`Invalid venture plan allocation amount: ${amount}`);
  }

  const coreFundAllocation = Math.floor(total * 0.4);
  const focusedFundAllocation = Math.floor(total * 0.2);
  const followOnFundAllocation = Math.floor(total * 0.2);

  return {
    coreFundAllocation,
    focusedFundAllocation,
    followOnFundAllocation,
    syndicationFundAllocation: total
      - coreFundAllocation
      - focusedFundAllocation
      - followOnFundAllocation,
  };
};

export default getDefaultFundAllocations;
